import { useSyncExternalStore } from 'react';

const MOBILE_BREAKPOINT = 768;
const DESKTOP_BREAKPOINT = 1280;

const MOBILE_MEDIA_QUERY = `(max-width: ${MOBILE_BREAKPOINT - 1}px)`;
const DESKTOP_MEDIA_QUERY = `(min-width: ${DESKTOP_BREAKPOINT}px)`;

const createMediaQueryHook = (mediaQuery: string) => {
  const subscribe = (onStoreChange: (event: MediaQueryListEvent) => void) => {
    const mediaQueryList = window.matchMedia(mediaQuery);
    mediaQueryList.addEventListener('change', onStoreChange);

    return () => {
      mediaQueryList.removeEventListener('change', onStoreChange);
    };
  };

  const getSnapshot = (): boolean => window.matchMedia(mediaQuery).matches;

  return () => useSyncExternalStore(subscribe, getSnapshot);
};

export const useIsMobile = createMediaQueryHook(MOBILE_MEDIA_QUERY);
export const useIsDesktop = createMediaQueryHook(DESKTOP_MEDIA_QUERY);
